import src from "IMAGE";
export default { src, width: 206, height: 64, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42g3LSwqAMAwFwG4FFUnFV2vz0UAWuf8B7WKWU5aD1gptuEAAqog0dx9m1oloL9s9zkfyVbHOzC0iNDO/yWegH88hBuUhbrXAAAAAAElFTkSuQmCC"};
